export enum FetchMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
}

export interface FetchServiceContract {
    fetch(url: string, object?: any, method?: FetchMethod): Promise<Response>;
    get<T>(url: string): Promise<T>;
    post<T>(url: string, object?: any): Promise<T>;
    delete<T>(url: string, body?: any): Promise<T>;
    put<T>(url: string, object: any): Promise<T>;

    buildAbsoluteUrl(url: string): string;
}
